import { useEffect } from 'react'

interface Props {
  overlayRef: React.RefObject<HTMLDivElement>
  setOverlayIsActive: React.Dispatch<React.SetStateAction<boolean>>
  linksSub: JSX.Element[]
}

const SubLinksOverlay: React.FC<Props> = ({
  overlayRef,
  setOverlayIsActive,
  linksSub,
}) => {
  useEffect(() => {
    document.body.classList.add('no-scroll')

    return () => {
      document.body.classList.remove('no-scroll')
    }
  }, [])

  useEffect(() => {
    const overlayCurrent = overlayRef.current
    if (overlayCurrent) {
      const handleClickInOverlay = (event: MouseEvent) => {
        const el = event.target as HTMLElement
        const closestDiv = el.closest('section')?.dataset.typeid
        if (closestDiv === 'sub-links-overlay') {
          setOverlayIsActive(false)
        }
      }

      document.addEventListener('mousedown', handleClickInOverlay)
      return () => {
        document.removeEventListener('mousedown', handleClickInOverlay)
      }
    }
  }, [overlayRef])

  return (
    <section
      data-typeid="sub-links-overlay"
      className="fixed top-0 right-0 bottom-0 left-0 z-[100] flex h-dvh w-dvw justify-end bg-[#1D1F23]/50 backdrop-opacity-90 backdrop-saturate-150"
      ref={overlayRef}
    >
      <section
        data-typeid="sub-links-modal"
        className="sub-links-modal-mobile mb-[60px] self-end"
      >
        <div className="mb-[5px] flex max-h-[200px] w-full flex-col items-start pl-[15px] text-xl">
          {linksSub}
        </div>
      </section>
    </section>
  )
}

export default SubLinksOverlay
